define('../app/fukit/behavior/hide.menu.item.with.empty.sub.menu.behavior',['require','exports','module','underscore','marionette'],function(require, exports, module) {
  //prettier-ignore
  var _  = require('underscore'),
      Mn = require('marionette');

  var HideMenuItemWithEmptySubMenuBehavior = Mn.Behavior.extend({
    onFirstRender: function() {
      var subMenu = this.view.subMenu;

      if (!subMenu) {
        return;
      } //only apply behavior to subMenus; Trees (collapsible menus) are a whole other story

      this.listenTo(this.view.subMenu, 'add remove childview:change:visible', this.checkNoVisibleChildren);
      this.checkNoVisibleChildren();
    },
    checkNoVisibleChildren: function() {
      var children = [];
      if (this.view.subMenu) {
        children = this.view.subMenu.toArray();
      }
      var hasVisibleChildren = _.any(children, function(child) {
        return child.visible;
      });
      this.view.visible = hasVisibleChildren;
    },
  });

  module.exports = HideMenuItemWithEmptySubMenuBehavior;
});

